import { addColumns } from '@nozbe/watermelondb/Schema/migrations'

export default {
  toVersion: 6,
  steps: [
    addColumns({
      table: 'messages',
      columns: [
        { name: 'header', type: 'string' },
        { name: 'footer', type: 'string' },
        { name: 'header_media', type: 'string' },
        { name: 'buttons', type: 'string' },
        { name: 'type', type: 'string' }
      ]
    })
  ]
}
